import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {FormMappersFactory} from '../../form/Mappers/factory.js'
import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {DraftEntitiesFactory} from '../Entities/factory.js'
import {DraftRepositoriesFactory} from '../Repositories/factory.js'

export class GetAdPublisherUseCase extends UseCase {
  #draftEntityFactory
  #fromDraftEntityToDraftFormValueObjectMapper
  #getCurrentUserService
  #httpRepository
  #userNotLoggedInUserError

  constructor({config}) {
    super()

    this.#draftEntityFactory = DraftEntitiesFactory.draftEntity
    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({
      config
    })
    this.#fromDraftEntityToDraftFormValueObjectMapper = FormMappersFactory.fromDraftEntityToDraftFormValueObject({
      config
    })
    this.#httpRepository = DraftRepositoriesFactory.hTTPDraftRepository({config})
    this.#userNotLoggedInUserError = UserErrorsFactory.userNotLoggedInUserError
  }

  static create({config}) {
    return new GetAdPublisherUseCase({config})
  }

  @tracer({metric: 'GetAdPublisherUseCase#execute'})
  @inlineError
  async execute({adId, categoryId}) {
    const userEntity = await this.#getCurrentUserService.execute()

    if (!userEntity) {
      return Promise.reject(
        this.#userNotLoggedInUserError({
          message: `[GetAdPublisherUseCase#execute] User not logged in`
        })
      )
    }

    const draftEntity = this.#draftEntityFactory({data: {id: adId, userId: userEntity.getId()}})

    const [getAdError, getAdResponse] = await this.#httpRepository.getAd({
      categoryId,
      draftEntity
    })

    if (getAdError) return Promise.reject(getAdError)

    const {status, data} = getAdResponse.toJSON()

    return {
      status,
      data: this.#fromDraftEntityToDraftFormValueObjectMapper
        .setParams({
          ...data
        })
        .map()
        .toJSON()
    }
  }
}

export const factory = GetAdPublisherUseCase.create
